import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_instanceh4txywgfetw1 as Companion_instance } from '../../../../../../../okio-parent-okio/okio/HashingSink.mjs';
import {
  blackholeSink1e341pykjnhp5 as blackholeSink,
  buffer10rjf0ze3bqic as buffer,
} from '../../../../../../../okio-parent-okio/okio/Okio.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from '../../../../../../../kotlinx-atomicfu/kotlinx/atomicfu/locks/Synchronized.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ApolloNetworkException3denf70pfh242 as ApolloNetworkException } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { SubscribableWebSockethkxzhdarcovi as SubscribableWebSocket } from './SubscribableWebSocket.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function cleanupLocked($this, key) {
  // Inline function 'kotlin.collections.iterator' call
  var iterator = $this.subscribableWebSockets_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (iterator.hasNext_bitz1p_k$()) {
    var entry = iterator.next_20eer_k$();
    if (entry.get_value_j01efc_k$().isShutdown_gfx72d_k$(entry.get_key_18j28a_k$().equals(key))) {
      iterator.remove_ldkf9o_k$();
    }
  }
}
function closeAllConnectionsLocked($this, cause) {
  // Inline function 'kotlin.collections.iterator' call
  var iterator = $this.subscribableWebSockets_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (iterator.hasNext_bitz1p_k$()) {
    var entry = iterator.next_20eer_k$();
    entry.get_value_j01efc_k$().shutdown_9u61jz_k$(cause, 1001, 'Client requested closing the connection');
    iterator.remove_ldkf9o_k$();
  }
}
function key($this, url, httpHeaders) {
  var hashingSink = Companion_instance.sha256_x3qc5b_k$(blackholeSink());
  // Inline function 'kotlin.apply' call
  var this_0 = buffer(hashingSink);
  this_0.writeUtf8_9rv3au_k$(url);
  this_0.writeByte_3m2t4h_k$(0);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = httpHeaders.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    this_0.writeUtf8_9rv3au_k$(element.name_1 + ': ' + element.value_1);
    this_0.writeByte_3m2t4h_k$(0);
  }
  this_0.flush_shahbo_k$();
  return hashingSink.get_hash_won4uv_k$();
}
var WebSocketPoolClass;
function WebSocketPool() {
  if (WebSocketPoolClass === VOID) {
    class $ {
      constructor(webSocketEngine, serverUrl, wsProtocol, connectionAcknowledgeTimeout, pingInterval, idleTimeout) {
        this.webSocketEngine_1 = webSocketEngine;
        this.serverUrl_1 = serverUrl;
        this.wsProtocol_1 = wsProtocol;
        this.connectionAcknowledgeTimeout_1 = connectionAcknowledgeTimeout;
        this.pingInterval_1 = pingInterval;
        this.idleTimeout_1 = idleTimeout;
        var tmp = this;
        // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
        tmp.lock_1 = get_atomicfu$reentrantLock();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.subscribableWebSockets_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
      }
      close_yn9xrc_k$() {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.lock_1;
        closeAllConnectionsLocked(this, ApolloNetworkException().new_com_apollographql_apollo_exception_ApolloNetworkException_7j59h6_k$('WebSocketNetworkTransport was closed'));
        this.webSocketEngine_1.close_yn9xrc_k$();
        return Unit_instance;
      }
      acquire_dgadfr_k$(apolloRequest) {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.lock_1;
        var tmp0_elvis_lhs = apolloRequest.url_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.serverUrl_1 : tmp0_elvis_lhs;
        var tmp;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = "ApolloRequest.url is missing for request '" + apolloRequest.operation_1.operationName() + "', did you call ApolloClient.Builder.webSocketServerUrl(url)?";
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var url = tmp;
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs_0 = apolloRequest.httpHeaders_1;
        var httpHeaders = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
        var key_0 = key(this, url, httpHeaders);
        cleanupLocked(this, key_0);
        var webSocket = this.subscribableWebSockets_1.get_wei43m_k$(key_0);
        if (webSocket == null) {
          webSocket = new (SubscribableWebSocket())(this.webSocketEngine_1, url, httpHeaders, this.wsProtocol_1, this.pingInterval_1, this.connectionAcknowledgeTimeout_1, this.idleTimeout_1);
          this.subscribableWebSockets_1.put_4fpzoq_k$(key_0, webSocket);
        }
        return webSocket;
      }
    }
    initMetadataForClass($, 'WebSocketPool');
    WebSocketPoolClass = $;
  }
  return WebSocketPoolClass;
}
//region block: exports
export {
  WebSocketPool as WebSocketPool28m608awosr6h,
};
//endregion

//# sourceMappingURL=WebSocketPool.mjs.map
